import { FC } from 'react';

import { IconProps } from '../types';

const HydratingIcon: FC<IconProps> = ({ size, ...props }) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    {...props}
    aria-hidden="true"
  >
    <path
      d="M29.9146 25.7833C29.8796 31.255 25.4696 35.7 19.9979 35.7C14.5263 35.7 10.0463 31.255 10.0813 25.7833C10.1279 18.2933 19.9979 4.19995 19.9979 4.19995C19.9979 4.19995 29.9613 18.2466 29.9146 25.7833Z"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.3516 31.2633C17.1316 31.2633 14.4949 28.6499 14.5182 25.4299"
      stroke="#030303"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export default HydratingIcon;
